import { CryptoExtensionUnavailableException } from "../../../../Cryptography/Crypto/CryptoExceptions";
import { Localization } from "../../../../OW.Remoting/Remoting/Localization";
import { createElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { IContentBuilder } from "./IContentBuilder";
/**
 * @internal
 */
export class CryptoExtensionUnavailableBuilder implements IContentBuilder {
    private readonly _exception: CryptoExtensionUnavailableException;
    private _content: HTMLElement;

    constructor(exception: CryptoExtensionUnavailableException) {
        this._exception = exception;
    }

    private async _buildMessageElement(): Promise<void> {
        const contentDiv = createElement({ classes: "crypto-component-unavailable-content" });

        const extensionMissingMessage = createElement({ type: "span", classes: "crypto-component-unavailable-message" });
        if (this._exception.downloadURL) {
            // "Pro podepisování musíte mít ve svém prohlížeči nainstalováno rozšíření Crypto Web Extension. Aktuální verzi si můžete stáhnout na: "
            extensionMissingMessage.innerText = await Localization.getTextPromise("GUI-625495");
            contentDiv.appendChild(extensionMissingMessage);

            const extensionDownloadLink = createElement({
                type: "a",
                value: "Crypto Web Extension",
                attrs: { href: this._exception.downloadURL, target: "_blank" },
            });
            contentDiv.appendChild(extensionDownloadLink);
        } else {
            // "Váš prohlížeč bohužel nepodporuje komponenty potřebné k podepisování. Použijte prosím kompatibilní prohlížeč. Aktuálně podporované prohlížeče: Google Chrome." // TODO: upravit seznam/link podporovaných prohlížečů
            extensionMissingMessage.innerText = await Localization.getTextPromise("GUI-625496");
            contentDiv.appendChild(extensionMissingMessage);
        }

        this._content = contentDiv;
    }

    public async build(): Promise<HTMLElement> {
        await this._buildMessageElement();
        return this._content;
    }
}
